const IslandRenderer = () => null
export default IslandRenderer